import styled from 'react-emotion'
import themeVars from 'ui_theme/site/globals/site.variables'

const PulsatingCircle = styled('div')`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  pointer-events: none;

  &:before {
    content: '';
    position: relative;
    display: block;
    width: ${props => props.size * 3}px;
    height: ${props => props.size * 3}px;
    box-sizing: border-box;
    margin-left: -100%;
    margin-top: -100%;
    border-radius: 999em;
    background-color: ${props => themeVars[props.color || 'berry']};
    transform: scale(0.33);
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    background-color: ${props => themeVars[props.color || 'berry']};
    border-radius: 999em;
    transform: scale(0.8);
  }
`

export default PulsatingCircle
